import { SVGProps, Ref, forwardRef } from 'react';

export const TramFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.997 14.1c-.073 4.33-.648 6.337-2.932 7.231l.89 2.669H17.06l-.745-2.231c-1.145.173-2.562.23-4.312.23-1.747 0-3.16-.057-4.305-.229L6.955 24H5.06l.887-2.666c-2.29-.892-2.866-2.9-2.94-7.235zm-13.14 1.8a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m8.3 0a1.25 1.25 0 1 0 .001 2.5 1.25 1.25 0 0 0 0-2.5"
                    fill="currentColor"
                />
                <path
                    d="M16.35 0c.743 0 1.367-.016 1.938.22.571.237 1 .69 1.526 1.215l.83.828-1.274 1.274-.828-.83c-.63-.629-.779-.756-.942-.824-.164-.067-.36-.083-1.25-.083h-3.443v2.208c6.838.091 8.027 1.346 8.096 8.291H3c.069-6.949 1.26-8.2 8.106-8.29V1.8H7.664c-.89 0-1.086.016-1.25.083-.164.068-.313.195-.942.824l-.828.83L3.37 2.263l.83-.828C4.724.909 5.153.457 5.725.22 6.296-.016 6.92 0 7.664 0z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
TramFilledSize24Glyph.displayName = 'TramFilledSize24Glyph';
